// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
var ProfilePhotoInput = require("../common/ProfilePicture/ProfilePhotoInput.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var AgentMarketingProfilePhotoFormMutation_graphql = require("../../__generated__/AgentMarketingProfilePhotoFormMutation_graphql.bs.js");
var AvatarDefaultSvg = require("../../../assets/images/elements/avatar-default.svg");
var AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.bs.js");
var AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.bs.js");
var AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql = require("../../__generated__/AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.bs.js");

var convertFragment = AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var avatarPlaceholder = AvatarDefaultSvg;

function AgentMarketingProfilePhotoForm$CurrentPhoto(props) {
  var marketingProfile = use(props.marketingProfile);
  var profilePicture = marketingProfile.profilePicture;
  var src = profilePicture !== undefined ? profilePicture.url : avatarPlaceholder;
  var match = marketingProfile.profilePicture;
  var alt = match !== undefined ? "Your current profile picture" : "Placeholder profile picture showing a person's silhouette";
  return JsxRuntime.jsx("img", {
              className: "w-24 h-24 rounded-full",
              alt: alt,
              src: src
            });
}

var CurrentPhoto = {
  Fragment: Fragment,
  avatarPlaceholder: avatarPlaceholder,
  make: AgentMarketingProfilePhotoForm$CurrentPhoto
};

var convertFragment$1 = AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertVariables = AgentMarketingProfilePhotoFormMutation_graphql.Internal.convertVariables;

var convertResponse = AgentMarketingProfilePhotoFormMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = AgentMarketingProfilePhotoFormMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, AgentMarketingProfilePhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var use$2 = RescriptRelay_Mutation.useMutation(convertVariables, AgentMarketingProfilePhotoFormMutation_graphql.node, convertResponse, convertWrapRawResponse);

var Mutation_imageContentType_decode = AgentMarketingProfilePhotoFormMutation_graphql.Utils.imageContentType_decode;

var Mutation_imageContentType_fromString = AgentMarketingProfilePhotoFormMutation_graphql.Utils.imageContentType_fromString;

var Mutation = {
  imageContentType_decode: Mutation_imageContentType_decode,
  imageContentType_fromString: Mutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$2
};

function AgentMarketingProfilePhotoForm$ChangeProfilePhoto(props) {
  var marketingProfile = use$1(props.marketingProfile);
  var match = use$2();
  var mutate = match[0];
  var match$1 = marketingProfile.profilePicture;
  var buttonText = match$1 !== undefined ? "Change photo" : "Add photo";
  return JsxRuntime.jsx(ProfilePhotoInput.make, {
              onSubmit: (function (param, param$1) {
                  var notifyOnError = param$1.notifyOnError;
                  var notifyOnSuccess = param$1.notifyOnSuccess;
                  mutate({
                        input: {
                          profilePhoto: {
                            croppedPhoto: param.croppedPhoto,
                            originalPhoto: param.originalPhoto
                          }
                        }
                      }, undefined, undefined, undefined, (function (_response, errors) {
                          if (errors !== undefined) {
                            return notifyOnError("There was an error saving your photo. Please try again.");
                          } else {
                            return notifyOnSuccess();
                          }
                        }), (function (param) {
                          notifyOnError("There was an error saving your photo. Please try again.");
                        }), undefined);
                }),
              buttonText: buttonText
            });
}

var ChangeProfilePhoto = {
  Fragment: Fragment$1,
  Mutation: Mutation,
  make: AgentMarketingProfilePhotoForm$ChangeProfilePhoto
};

var convertFragment$2 = AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(AgentMarketingProfilePhotoForm_agentMarketingProfile_graphql.node, convertFragment$2, fRef);
}

var Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$3,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function AgentMarketingProfilePhotoForm$WithoutErrorBundary(props) {
  var marketingProfile = use$3(props.marketingProfile);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Form__Label.make, {
                                    labelText: "Profile Picture"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: "Upload a headshot to show at the top of your profile next to your name.",
                                    className: "text-base text-zinc-500"
                                  })
                            ]
                          }),
                      className: "pt-2 col-span-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(AgentMarketingProfilePhotoForm$CurrentPhoto, {
                              marketingProfile: marketingProfile.fragmentRefs
                            }),
                        JsxRuntime.jsx(AgentMarketingProfilePhotoForm$ChangeProfilePhoto, {
                              marketingProfile: marketingProfile.fragmentRefs
                            })
                      ],
                      className: "mt-2 sm:col-span-3 sm:mt-0 sm:max-w-xs flex gap-6 items-center md:flex-col lg:flex-row"
                    })
              ],
              className: "sm:grid sm:grid-cols-5 sm:items-start sm:gap-16 sm:py-6 space-y-6"
            });
}

var WithoutErrorBundary = {
  make: AgentMarketingProfilePhotoForm$WithoutErrorBundary
};

function AgentMarketingProfilePhotoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "Profile photo",
              children: JsxRuntime.jsx(AgentMarketingProfilePhotoForm$WithoutErrorBundary, {
                    marketingProfile: props.marketingProfile
                  })
            });
}

var make = AgentMarketingProfilePhotoForm;

exports.CurrentPhoto = CurrentPhoto;
exports.ChangeProfilePhoto = ChangeProfilePhoto;
exports.Fragment = Fragment$2;
exports.WithoutErrorBundary = WithoutErrorBundary;
exports.make = make;
/* avatarPlaceholder Not a pure module */
